export default __webpack_public_path__ + "static/media/blog-joint-sand-002.5bf6d1b7.jpg";